import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';

import { DropDown, DropDownProps } from '../DropDown';
import { colors } from '../colors';
import { IconButton } from '@mui/material';
import { Sort } from '@client/new/helpers/sorting';

export type SortBadgeProps<T> = Pick<DropDownProps<T>, 'items'> & {
  value: Sort<T>;
  items: Array<{ value: T; label: string }>;
  onChange: (sort: Sort<T>) => void;
};

export const SortBadge = <T,>(p: SortBadgeProps<T>) => (
  <div
    className="flex items-center gap-2 text-xs uppercase font-semibold rounded-3xl px-1.5 py-0.5"
    style={{
      color: colors.primaryDark600,
      background: colors.secondary200,
    }}
  >
    <IconButton
      size="small"
      className="rounded-full p-1 w-5 h-5"
      sx={{ background: colors.primaryDark600, color: 'white' }}
      onClick={() =>
        p.onChange({
          type: p.value.type === 'asc' ? 'desc' : 'asc',
          field: p.value.field,
        })
      }
    >
      <FontAwesomeIcon
        className="w-2.5"
        icon={p.value.type === 'asc' ? faArrowUp : faArrowDown}
      />
    </IconButton>

    <DropDown
      variant="inherit"
      items={p.items}
      value={p.value.field}
      hideIcon
      onChange={(field) => p.onChange({ type: p.value.type, field })}
    />
  </div>
);
